import { makeStyles, tokens, Spinner } from '@fluentui/react-components';
import { useTranslation } from 'react-i18next';
import { PrimaryButton } from '../../shared/StyledCommonComponents';

const useStyles = makeStyles({
    loadingContainer: {
        display: 'flex',
        alignItems: 'center',
        gap: tokens.spacingHorizontalS,
    },
});

interface CallbackConfirmButtonProps {
    onConfirm?: () => void;
    isLoading?: boolean;
    disabled?: boolean;
}

export const CallbackConfirmButton: React.FC<CallbackConfirmButtonProps> = ({
    onConfirm,
    isLoading = false,
    disabled = false,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <PrimaryButton type="submit" onClick={onConfirm} disabled={disabled || isLoading}>
            {isLoading ? (
                <div className={classes.loadingContainer}>
                    <Spinner size="tiny" />
                    {t('callback.confirmButton')}
                </div>
            ) : (
                t('callback.confirmButton')
            )}
        </PrimaryButton>
    );
};
